/* eslint-disable jsx-a11y/anchor-is-valid */
// import clsx from 'clsx'
import {FC} from 'react'
import {useIntl} from 'react-intl'
// import {toAbsoluteUrl} from '../../../../../../../../_metronic/helpers'
import {EvaluationReport} from '../../core/_models'

type Props = {
  evaluationReport: EvaluationReport
}

const EvaluationReportTypeCell: FC<Props> = ({evaluationReport}) => {
  const intl = useIntl()
  return (
    <div className='d-flex align-items-center justify-content-center '>
      <div className='d-flex flex-column'>
        <a href='#' className='text-gray-600 text-center fs-8 mb-1'>
          {evaluationReport?.type === 'direct_damage' && (
            <div
              className='badge badge-success fw-bolder fs-9'
              style={{
                whiteSpace: 'pre-line',
              }}
            >
              {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.DIRECT_DAMAGE'})}
            </div>
          )}
          {evaluationReport?.type === 'business_interruption' && (
            <div
              className='badge badge-success fw-bolder fs-9'
              style={{
                whiteSpace: 'pre-line',
              }}
            >
              {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.BUSINESS_INTERRUPTION'})}
            </div>
          )}
          {evaluationReport?.type === 'annual_servitude' && (
            <div
              className='badge badge-success fw-bolder fs-9'
              style={{
                whiteSpace: 'pre-line',
              }}
            >
              {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.ANNUAL_SERVITUDE'})}
            </div>
          )}
          {evaluationReport?.type === 'single_servitude' && (
            <div
              className='badge badge-success fw-bolder fs-9'
              style={{
                whiteSpace: 'pre-line',
              }}
            >
              {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.SINGLE_SERVITUDE'})}
            </div>
          )}
        </a>
      </div>
    </div>
  )
}

export {EvaluationReportTypeCell}
